import React, {useEffect} from "react";
import {NavLink, useNavigate} from "react-router-dom";
import ContentBox from "../../../../../components/content-box/ContentBox";
import PageActions from "../../../../base/PageActions";
import Breadcrumbs from "../../../../../components/breadcrumbs/Breadcrumbs";
import ImageLink from "../../../../../components/image-link/ImageLink";
import _http_service from "../../../../../services/HttpService";
import _image_service from "../../../../../services/ImageService";
import _naming_service from "../../../../../services/NamingService";
import '../../../../styles/Common.scss';
import '../WorldPages.scss';
import './BotanaryPage.scss';

interface BotanaryPageProps {
}

const BotanaryPage = (props: BotanaryPageProps) => {

    const page: PageActions = new PageActions({
        title: `Casarok Botanary - Chase the Fox`,
        description: "The world of Casarok has a wide variety of plant life that cannot be found anywhere else in the universe!",
        keywords: ["casarok", "botanary", "magic plant", "fantasy plant", "fantasy flora"],
        imgSrc: `chase/world/botanary/yulaberry.png`,
        url: `world/botanary`
    });

    const [entries, setEntries] = React.useState<string[]>([]);

    const navigateTo = useNavigate();

    useEffect(() => {
        _http_service.getWorldTopics('botanary')
            .then(data => setEntries(data))
            .catch(() => navigateTo("/error", {replace: true}));
    }, []);

    const normalizeEntryName = (name: string): string => {
        return name.toLowerCase().replace(/ /g, "-");
    }

    return page.generateMetaContent(
        <>
            <ContentBox header="Botanary">
                <Breadcrumbs path={page.getUrl()}/>
                <p>
                    Casarok is home to many different species of plants. While most of them are similar to those found
                    on Earth, many new species of plants have arisen through the ages and the magical nature of the
                    planet. These unique flora empowered the denizens of early Casarok, and some are still in use to
                    this very day.
                </p>
                <p>
                    Please note that the botanary here does not take into account the classification of life known
                    as <NavLink className="world-link" to="/world/bestiary/floradon">Floradons</NavLink>. These are
                    all non-sentient plant life the previously mentioned classification is maintained separately from
                    this group.
                </p>
                <p>
                    A listing of the various species of plant life unique to Casarok are listed here:
                </p>
                <ul className="botanary-subsection-list">
                    {entries.map((entry) => (
                        <li
                            key={`botanary-${normalizeEntryName(entry)}`}>
                            <ImageLink className="world-link"
                                       imgSrc={_image_service.getCdnImageSrc(`chase/world/botanary/${normalizeEntryName(entry)}.png`)}
                                       linkUrl={`/world/botanary/${normalizeEntryName(entry)}`}
                                       linkName={_naming_service.capitalizeName(entry)}/>
                        </li>
                    ))}
                </ul>
            </ContentBox>
        </>
    );
}

export default BotanaryPage;